import { render, staticRenderFns } from "./PhotosPage.vue?vue&type=template&id=0724c9d1&"
import script from "./PhotosPage.vue?vue&type=script&lang=js&"
export * from "./PhotosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports